import SpecialStoreList from './SpecialStoreList'

export default SpecialStoreList
